import {Col, Row} from 'antd';
import React, {useState, useEffect} from 'react';

import BRSR from '../../../assets/BRSR.png';
import GRI from '../../../assets/GRI.png';
import SASB from '../../../assets/SASB.png';
import Scope1 from '../../../assets/Scope1.png';
import Scope2 from '../../../assets/Scope2.png';
import Scope3 from '../../../assets/Scope3.png';
import TCFD from '../../../assets/TCFDIcon.png';

import AddBtn from './AddBtn';
import HeaderTitle from './HeaderTitle';

interface BusinessItem {
  title: string;
  logo: string;
  details: string;
  actionType: any;
  selected: boolean;
}

interface KnowledgeBaseInterface {
  logo: string;
  details: string;
  actionType: any;
  selected: boolean;
}

const KnowledgeBase: React.FC = () => {
  const [data, setData] = useState<BusinessItem[]>([
    {
      title: 'Scope 1',
      logo: Scope1,
      details: 'Direct GHG Emissions',
      actionType: 'Learn more',
      selected: false
    },
    {
      title: 'Scope 2',
      logo: Scope2,
      details: 'Electricity Indirect GHG Emissions',
      actionType: 'Learn more',
      selected: false
    },
    {
      title: 'Scope 3',
      logo: Scope3,
      details: 'Other Indirect GHG Emissions',
      actionType: 'Learn more',
      selected: false
    }
  ]);

  const [KnowledgeData, setKnowledgeData] = useState<KnowledgeBaseInterface[]>([
    {
      logo: GRI,
      details: 'Global Reporting Initiative',
      actionType: 'Learn more',
      selected: false
    },
    {
      logo: BRSR,
      details: 'Business Responsibility and Sustainability Report',
      actionType: 'Learn more',
      selected: false
    },
    {
      logo: SASB,
      details: 'Sustainability Accounting Standards Board',
      actionType: 'Learn more',
      selected: false
    },
    {
      logo: TCFD,
      details: 'Task Force on Climate-Related Financial Disclosures',
      actionType: 'Learn more',
      selected: false
    }
  ]);

  useEffect(() => {
    setData((prev) => [...prev]);
    setKnowledgeData((prev) => [...prev]);
  }, []);

  return (
    <div className="getStartedContainer">
      <HeaderTitle
        headText={'Knowledge Base'}
        subText={''}
        hasOption={false}
        scrollNext={undefined}
        scrollPrev={undefined}
      />
      <Row gutter={[16, 16]} style={{height: 'fit-content', width: '100%'}}>
        {data.map((item, index) => (
          <Col key={index} span={8}>
            <div className="cardComponent">
              <div className="titleRow">
                <h3 className="cardTitle">{item.title}</h3>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <img className="logoStyle" src={item?.logo} />
                <p className="knowDetails">{item.details}</p>
                <a
                  href={'https://www.bharatcarbon.earth/glossary'}
                  target="_blank"
                  rel="noreferrer"
                >
                  <AddBtn
                    isSelected={item.selected}
                    actionProp={item.actionType}
                  />
                </a>
              </div>
            </div>
          </Col>
        ))}
        {KnowledgeData.map((item, index) => (
          <Col key={index} span={6}>
            <div className="knowledgeCardContainer">
              <img src={item.logo} alt="logo" className="bottomLogo" />
              <p className="knowDetails" style={{height: '5.5vh'}}>
                {item.details}
              </p>
              <a
                href={'https://www.bharatcarbon.earth/glossary'}
                target="_blank"
                rel="noreferrer"
              >
                <AddBtn
                  isSelected={item.selected}
                  actionProp={item.actionType}
                />
              </a>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default KnowledgeBase;
